<template>
  <div id="wrapper" style="height: 100%">
    <app-header></app-header>
    <researcher-sidebar v-if="userHasResearcherRole()"></researcher-sidebar>
    <admin-sidebar v-if="userHasAdminRole()"></admin-sidebar>
    <park-sidebar v-if="userHasParkRole()"></park-sidebar>
    <partner-sidebar v-if="userHasPartnerRole()"></partner-sidebar>
    <div class="content-wrapper">
      <section class="content">
        <slot></slot>
      </section>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from './Header'
import ResearcherSidebar from './ResearcherSidebar'
import AdminSidebar from './AdminSidebar'
import ParkSidebar from './ParkSidebar'
import PartnerSidebar from './PartnerSidebar'
import AppFooter from './Footer'
import Authentication from '@/services/authentication'

export default {
  name: 'Adminlte',
  components: {
    AppHeader,
    ResearcherSidebar,
    AdminSidebar,
    ParkSidebar,
    PartnerSidebar,
    AppFooter
  },
  mounted () {
    document.body.classList = 'sidebar-mini ' + this.$config.adminlte.skin
    this.fixContentWrapperSize()
  },
  methods: {
    fixContentWrapperSize () {
      var windowHeight = $(window).height()
      var footerHeight = $('.main-footer').outerHeight() || 0
      var headerHeight = $('.main-header').outerHeight() || 0
      $('.content-wrapper, .right-side').css('min-height', windowHeight - footerHeight - headerHeight)
    },
    userHasResearcherRole () {
      return Authentication.userHasResearcherRole()
    },
    userHasAdminRole () {
      return Authentication.userHasAdminRole()
    },
    userHasParkRole () {
      return Authentication.userHasParkRole()
    },
    userHasPartnerRole () {
      return Authentication.userHasPartnerRole()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Adminlte.vue?450f65ba